const URL_PATTERN = /https?:\/\/[^\s"'<>]+/g;
const DOMAIN_PATTERN = /(?:[\w-]+\.)+[\w-]{2,}/g;

const extractHostnames = (text: string): string[] => {
  const hostnames: string[] = [];
  const seen = new Set<string>();

  const urlMatches = text.match(URL_PATTERN);
  if (urlMatches) {
    for (const match of urlMatches) {
      try {
        const { hostname } = new URL(match);
        if (!seen.has(hostname)) {
          seen.add(hostname);
          hostnames.push(hostname);
        }
      } catch {
        // skip invalid URLs
      }
    }
  }

  // Remove URLs from text before searching for bare domains
  let textWithoutUrls = text;
  if (urlMatches) {
    for (const match of urlMatches) {
      textWithoutUrls = textWithoutUrls.replace(match, '');
    }
  }

  const domainMatches = textWithoutUrls.match(DOMAIN_PATTERN);
  if (domainMatches) {
    for (const match of domainMatches) {
      try {
        const { hostname } = new URL(`https://${match}`);
        if (!seen.has(hostname)) {
          seen.add(hostname);
          hostnames.push(hostname);
        }
      } catch {
        // skip invalid domains
      }
    }
  }

  return hostnames;
};

export default extractHostnames;
